// utils.js
//import CryptoJS from 'crypto-js';
//import md5 from 'md5';
import { Genv } from './global';
import busemiter from './busemiter';
const beepSound = new (window.AudioContext || window.webkitAudioContext)();
const isSet = (valor) => {
      if (valor === null || valor === "" || typeof valor == "undefined") 
        return false;
    
    if (valor === true || valor === false) 
        return true;
    
    if (typeof valor === "boolean" || (typeof valor === "number" && valor != 0)) 
        return true;
    
    return true;
}

const swLocal = (process.env.NODE_ENV === 'development') ? true : false;

const getSessionData = (key)  =>{

  const data = sessionStorage.getItem(key);
  try {
    const dataVal = JSON.parse(data);
    return dataVal.value; 
  }
  catch (e) { return data; }
}

const setSessionData = (key, value) => {

  return sessionStorage.setItem(key,JSON.stringify({"value":value}))
}


const newDate = (sdate=new Date()) => {
    if (isSet(sdate) && typeof sdate == "string") {
      // eslint-disable-next-line no-useless-escape
      const expTime = new RegExp("(\d{4})[-|/](\d{1,2})[-|/](\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})");
      if (expTime.test(sdate)) sdate = sdate.replace(expTime, "$1-$2-$3T$4:$5:$6") /* typeof sdate */
    }
    var dateVal = (!sdate) ? new Date(sdate) : new Date();
    var date = dateVal.toLocaleString('en-US', { timeZone: 'America/Bogota' }); /* typeof sdate */
    if (date == "Invalid Date" && isSet(sdate)) return false;

    const exp1 = /(\d{1,2})\/(\d{1,2})\/(\d{4}), (\d{1,2}):(\d{1,2}):(\d{1,2}) ([A|P]M)/;
    const arDate = exp1.exec(date);
    date = {
      getDate: () => { return parseInt(arDate[2]) },
      getMonth: () => { return parseInt(arDate[1]) - 1 },
      getFullYear: () => { return parseInt(arDate[3]) },
      getHours: () => {
        if (arDate[7] == "PM" && parseInt(arDate[4]) < 12) return parseInt(arDate[4]) + 12;
        if (arDate[7] == "PM" && parseInt(arDate[4]) == 12) return 12;
        return parseInt(arDate[4]);

        //return (arDate[7] == "PM") ? ((parseInt(arDate[4]) == 12) ? 0 : parseInt(arDate[4]) + 12) : parseInt(arDate[4])
      },
      getMinutes: () => { return parseInt(arDate[5]) },
      getSeconds: () => { return parseInt(arDate[6]) },
    }
    var dj = { "day": ("0" + date.getDate()).slice(-2), "month": ("0" + (date.getMonth() + 1)).slice(-2), "year": date.getFullYear(), "hours": date.getHours(), "minutes": date.getMinutes(), "seconds": date.getSeconds() }
    var strHours = (dj.hours < 10) ? "0" + dj.hours : dj.hours;

    var strHours12 = (dj.hours % 12 < 10) ? "0" + dj.hours % 12 : dj.hours % 12;
    var strMinutes = (dj.minutes < 10) ? "0" + dj.minutes : dj.minutes;

    var strSeconds = (dj.seconds < 10) ? "0" + dj.seconds : dj.seconds;
    dj.toString = (new Date()).toString();
    dj.toISODate = ("0" + dj.day).slice(-2) + "/" + ("0" + dj.month).slice(-2) + "/" + dj.year;
    dj.yyyymmdd = dj.year + "-" + ("0" + dj.month).slice(-2) + "-" + ("0" + dj.day).slice(-2);
    dj.toISOString = dj.day + "/" + ("0" + dj.month).slice(-2) + "/" + dj.year + " " + strHours + ":" + strMinutes + ":" + strSeconds;
    dj.toHourly12 = dj.day + "/" + dj.month + "/" + dj.year + ", " + ((dj.hours < 12) ? strHours12 : (dj.hours % 12 == 0) ? 12 : strHours12) + ":" + strMinutes + ((dj.hours < 12) ? " AM" : " PM");
    dj.timeStamp = parseInt(Date.now() / 1000);
    dj.timeStampFull = parseInt(Date.now() / 1000);
    dj.format = (str) => {
      return str.replace("dd", ("0" + dj.day).slice(-2)).replace("MM", ("0" + dj.month).slice(-2)).replace("yyyy", dj.year).replace("hh", ("0" + dj.hours).slice(-2)).replace("mm", ("0" + dj.minutes).slice(-2)).replace("ss", ("0" + dj.seconds).slice(-2))
    }
    dj.val = dateVal.getTime();
    return dj;
}
  

/*
  class Crypt {
    constructor() {
      this.utf8 = CryptoJS.enc.Utf8;
      this.k = "datosowl360sas901279270;"
    }
    encrypt(data) {
      //console.log(this.k)
            return CryptoJS.AES.encrypt(data, this.k).toString();

      //return crypto.AES.encrypt(JSON.stringify({"data":data}), this.k).toString();
    }

    decrypt(encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.k);
      const json = JSON.parse(bytes.toString(this.utf8));
      return json.data
    }
  
  }

const crypt = new Crypt();
export const encrypt = crypt.encrypt;
export const decrypt = crypt.decrypt;

*/



const isNotSet = (valor) => {
    if (valor === false || valor === true || valor === 0 || valor === "0")
        return false;
        
    if (valor === null || valor == "" || typeof valor == "undefined")
        return true;
    else
        return false;
        
};

const arMatchs = (str)  => {
    const pattern = /{{([a-zA-Z0-9]+)}}|{{([a-zA-Z0-9]+)}}-{{([a-zA-Z0-9]+)}}/g;
    const matches = [...str.matchAll(pattern)];
    
    if (matches.length === 0) {
        return [str];
    }
    
    const fields = matches.map(match => match[1]);
    
    return fields;
}

const replaceKeys = (str, data) => {
    const fields = arMatchs(str);
    const isVarFields = /{{[\w\-_]+}}/.test(str);
    fields.forEach(field => {
      const nestedFields = field.split('.');
      var nestedValue = ""
        if (nestedFields.length == 1) {
            nestedValue = data[field] || "";
        }
        else {
            nestedValue = { ...data };      
            for (const nestedField of nestedFields) {
                nestedValue = nestedValue[nestedField];       
                if (nestedValue === undefined) {
                    nestedValue = "";
                    break;
                }
            } 
        }
     
        str = (isVarFields) ? str.replace(new RegExp(`{{${field}}}`, 'gm'), nestedValue) : nestedValue;
    });
    
    return str;
}

const isFields = (str) => {
    const pattern = /{{[a-zA-Z0-9]+}}|{{[a-zA-Z0-9]+}}-{{[a-zA-Z0-9]+}}/g;
    return pattern.test(str);
}

const getStore = (key) => {
  return Genv.store.getters[key]
}
const setStore = (key,value) => {
  Genv.store.commit(key, value);
}
const msgTo = (msg) => {
  Genv.store.commit('setMessage', msg);
}

/*const keyConfirm = (email) => {

  const md5Hash = md5(email.toLowerCase());
  const filteredHash = md5Hash.replace(/[oi01]/g, '');
  const code = filteredHash.substr(0, 8);
  return code;
};*/

const isLoading = (st) => {
   busemiter.$emit("isLoading",st)
}

 const doReplace = (msgFrom, data) => {

        var arFields = arMatchs(msgFrom)
        if (arFields.length == 0) return msgFrom;
        for (var f in arFields)
            msgFrom = msgFrom.replace(new RegExp("{{" + arFields[f] + "}}", "gm"), getValueField(arFields[f], data))
        return msgFrom;
}

const getValueField = (field, dataOri) => {
        var data = Object.assign({}, dataOri)
        var arField = (field).split(".");
        if (!data[arField[0]]) return "";
        if (arField.length > 1) {
            field = arField[1];
            data = data[arField[0]]
        }
        const { fieldName, type } = getValueType(field);
        const preValue = (isSet(data[fieldName])) ? data[fieldName] : "";
        const value = ((type === false || type == "string") ? preValue : ((type == "int") ? parseInt(preValue) : ((type == "float" ? parseFloat(preValue) : preValue))))
        return value;
}

const getValueType = (field) => {
    if (field.split("::").length > 1) return { field: field.split("::")[0], type: field.split("::")[1] }
    return { fieldName: field, type: false }
}

const getCache = async (key) => {
    const keyDoc = Genv.fs.collection("memCached").doc(key);
    let dataKey = await keyDoc.get();
    if (!dataKey) return false;
    if (typeof dataKey == "string" && dataKey.startsWith("{")) dataKey = JSON.parse(dataKey)
    return dataKey;
}

const beep = (frequency, type, duration,volume = 100) => {
    return new Promise((resolve, reject) => {
            duration = duration || 100;
            frequency = frequency || 300;
            volume = volume || 100;
            type = type || "square"
            try{
                let oscillatorNode = beepSound.createOscillator();
                let gainNode = beepSound.createGain();
                oscillatorNode.connect(gainNode);
    
                oscillatorNode.frequency.value = frequency;
    
                oscillatorNode.type= type;
                gainNode.connect(beepSound.destination);
    
                gainNode.gain.value = volume * 0.01;
    
                oscillatorNode.start(beepSound.currentTime);
                oscillatorNode.stop(beepSound.currentTime + duration * 0.001);
                oscillatorNode.onended = () => {
                    resolve();
                };
            }catch(error){
                reject(error);
            }
        });

  
    }

const getDataDOM = (id)=> {
  const contenedor = document.getElementById(id);
  if (contenedor) {
    const rect = contenedor.getBoundingClientRect();
    const {left, top, x, y, right, bottom, height, width} = rect;
    return {left, top, x, y, right, bottom, height, width};
  }

  return {left:0,top:0,x:0,y:0,rigth:0,bottom:0,height:0,width:0};
}



export {
  isSet,
  isNotSet,
  newDate,
  arMatchs,
  doReplace,
  replaceKeys,
  isFields,
  swLocal,
  getSessionData,
  setSessionData,
  getDataDOM,
  //keyConfirm,
  //md5,
  getStore,
  setStore,
  msgTo,
  isLoading,
  getValueField,
  getValueType,
  getCache,
  beep
};
